module.exports = __webpack_public_path__ + "img/bell.0f09048e.jpg";